import { DialogButton, WindowsServiceContract  } from '@/core/contracts/windowsServiceContract';

export interface TileData {
    key: string;
    name: string;
    args?: any;
    box: Box;
}

export enum Direction {
    Horizontal = 'h',
    Vertical = 'v',
}

export enum Position {
    Top = 'top',
    Right = 'right',
    Bottom = 'bottom',
    Left = 'left',
}

export interface ContainerData {
    direction: Direction;
    ratio: number;
    boundingBox: Box;
    key: string;
}

export interface Box {
    top: number;
    right: number;
    bottom: number;
    left: number;
}

// tslint:disable-next-line: no-empty-interface
export interface TilesContainer extends WindowsServiceContract {
}

export interface Dialog {
    id: number;
    args: any;
    component: any;
    close: (id: any) => void;
}
